// 生产环境 API 走独立 CDN 域名；本地开发走相对路径 + setupProxy
export const API_ORIGIN =
    process.env.NODE_ENV === 'production'
        ? 'https://jtg-api.lvdangjia.net'
        : '';

export const DIAN_SHANG_YE_WU_API_BASE = `${API_ORIGIN}/DianShangYeWuApi`;

// 本地 /api 会被 setupProxy 去掉前缀回源；生产直连源站真实路径
export const ASSETS_APPLICATION_BASE =
    process.env.NODE_ENV === 'production'
        ? `${API_ORIGIN}/assets/images/application`
        : '/api/assets/images/application';

export const REACT_API_SINGLE_UPLOAD =
    process.env.NODE_ENV === 'production'
        ? `${API_ORIGIN}/ReactApi/zd_single_upload_image`
        : '/api/ReactApi/zd_single_upload_image';
